import clsx from "clsx";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers";

export interface IIconButton {
    src?: string;
    onClick?: () => void;
    width?: string | number;
    height?: string | number;
    style?: React.CSSProperties;
    color?: string;
    cssClass?: string[];
}
const IconButton = (props: IIconButton) => {
    const {
        src = "/media/icons/duotune/general/gen044.svg",
        onClick = () => {},
        width,
        height,
        style,
        color,
        cssClass,
    } = props;
    return (
        <SVG
            className={`iconButton ${clsx(cssClass || [])}`}
            width={width}
            height={height}
            onClick={onClick}
            style={style}
            color={color}
            src={toAbsoluteUrl(src)}
        />
    );
};

export default IconButton;
